import Swiper, { Navigation } from "swiper";

const GridSlider = () => {
	const gridSlider = document.getElementsByClassName("grid-slider");
	Swiper.use([Navigation]);

	const initSlider = (section) => {
		const swiperContainer = section.querySelector(".swiper-container");

		/* eslint-disable no-unused-vars */
		const swiperInstance = new Swiper(swiperContainer, {
			// Optional parameters
			grabCursor: true,
			slidesPerView: 1.2,
			spaceBetween: 16,

			// Responsive
			breakpoints: {
				640: {
					grabCursor: true,
					slidesPerView: 2.1,
					spaceBetween: 16,
				},
				1024: {
					grabCursor: true,
					slidesPerView: 3,
					spaceBetween: 24,
				},
			},

			// Navigation arrows
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},

			on: {
				/* eslint-disable */
				init: function () {
					const swiper = swiperContainer.swiper;

					if (swiper.slides.length > 3) {
						// swiper activated
						swiperContainer.classList.remove("swiper-disabled");
					} else if (swiper.slides.length <= 3) {
						// swiper deactivated
						swiperContainer.classList.add("swiper-disabled");
					}
				},

				/* eslint-enable */
			},
		});
		/* eslint-enable no-unused-vars */
	};

	if (gridSlider[0]) {
		Array.from(gridSlider).forEach((section) => initSlider(section));
	}
};

export default GridSlider;
